<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 09:50:46
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-07 11:54:26
 * @name: 注册成功
 * @Description: 注册成功
 * @FilePath: \backstage\src\components\register\set-result.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="registerSetResult">
    <i class="el-icon-success"></i>
    <font>注册成功</font>
    <el-button type="primary" @click="goback">返回</el-button>
  </div>
</template>
<script>
export default {
  name: "registerSetResult",
  methods: {
      goback() {
          this.$router.go(-1);
      }
  }
};
</script>
<style lang="scss" scoped>
$margin: 30px;
.registerSetResult {
  width: 100%;
  @extend .extend-flex-center;
  flex-direction: column;
  .el-icon-success {
    font-size: 200px;
    color: $Vars-success-color;
    margin-bottom: $margin;
  }
  font {
    color: $Vars-font-important-color;
    font-weight: bold;
    font-size: $Vars-font-mainTitle-size;
    margin-bottom: $margin;
  }
  .el-button{
      width: 120px;
  }
}
</style>